import React, { useState, useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";

import LoadingScreen from "react-loading-screen";
import "react-responsive-pagination/themes/classic.css";
import { useHistory } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Label,
  Row,
  Col,
  CustomInput,
} from "reactstrap";
import axios from "axios";
import {
  SAVE_GROUP,
  FETCH_GROUP_BY_NAME,
  FETCH_GROUP_NAMES 
  
} from "../../constants";
import SampleCSV from "./groups.csv";
import NotificationAlert from "react-notification-alert";

let groupnames=[]
const initialState = [{
  name: "",
  mobile: "",
  email: ""
}
];
const CreateGroup = (props) => {
  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const notificationAlertRef = React.useRef(null);
  const [contacts, setContacts] = useState(initialState);
  const [groupname, setGroupname] = useState("")
  const [file, setFile] = useState(null);
  const [error, setError] = useState();
  const [ismanual, setIsManual] = useState(0)

  let lcObj = localStorage.getItem("user");
  let lclStrge = JSON.parse(lcObj);
  let user_id=lclStrge?.user_id;

  useEffect(() => {
    fetchgroup()
    props?.location?.state?.id && fetchUserDtls();
 
  }, []);
  const fetchgroup=()=>{
    groupnames = []
    axios
        .get(`${FETCH_GROUP_NAMES}?user_id=${user_id}`)
        .then((response) => {
          const res = response?.data;
       
        groupnames.push(res?.message)
        })
  }
  const fetchUserDtls = () => {
    if (props?.location?.state?.id) {
      let id = props?.location?.state?.id;
      let groupArr = [];
      axios
        .get(`${FETCH_GROUP_BY_NAME}?id=${id}`)
        .then((response) => {
          const res = response?.data;
          const cntctsJson = JSON.parse(res[0]?.contacts)
          cntctsJson?.map((item, index) => {
          
            groupArr.push({
              id: item?.id,
              name: item?.name,
              mobile: item?.mobile,
              email: item?.email
            })
            // setContacts(pregroup=>({...pregroup,
            //   name: item?.contact_name,
            //   mobile: item?.mobile,
            //   email: item?.email
            // }))
            // setContacts([{...contacts,
            //   name: item?.contact_name,
            //   mobile: item?.mobile,
            //   email: item?.email
            // }])
          })
          // drpdwn.push({ value: res.client, label: res.client})
          //   const clientObj = clientsList.filter(item=>item.value===res.client)

          // setUsers({
          //   username: res?.username,
          //   password: res?.password,
          //   mobile: res?.mobile,
          //   email: res?.email,
          //   senderId: res?.senderid,
          //   firstName: res?.first_name,
          //   lastName: res?.last_name,
          //   profile: res?.image_url,
          //   client: clientObj[0],
          //   role:{ value: res.role, label: res.role },
          //   status:res.status
          // });


          setContacts(groupArr)
          setGroupname(res[0].name)

        })
        .catch((error) => {
          console.log("????", error);
        });
    }
  };
  const onchangeHandler = (event, i) => {
    const { name, value } = event.target;
   
      let contactsdata = contacts.map((item, index) => {
     

        if (i == index) {
          return { ...item, [name]: value };
  
        }
        return item;
      });
  
      setContacts(contactsdata);
      const isExist = contacts?.filter((cont,i)=>cont?.mobile?.toLocaleLowerCase()==value ||cont?.email?.toLocaleLowerCase()==value)
      
      if (isExist?.length>0) {
        setError({...error,
          [name]:`Already Exist`
        })
      }else{
        setError({...error,[name]:""})
      }
   
  };

  const submitgroup = async() => {


    const payload = new FormData();
    payload.append('contacts', JSON.stringify(contacts))
    payload.append('groupname', groupname)
    payload.append('client_id', user?.client)
    payload.append('user_id', user?.user_id)
    payload.append('file', file)


    const isvalid = validate()
    
    
    const cleanedObj = Object.fromEntries(
      Object.entries(isvalid).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
  );
  setError(cleanedObj)
    if (Object?.keys(cleanedObj)?.length === 0) {
      if (props?.location?.state?.id) {
        payload.append("id", props?.location?.state?.id.toString())
       
       await axios
          .post(SAVE_GROUP, payload)
          .then((response) => {

            let options = {};
            options = {
              place: "tr",
              message: "Updated Successfully",
              type: "success",

              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);

            setTimeout(() => {
              navigate.push("/admin/groups/groups");
            }, 1000)
          })
          .catch((error) => {
            console.log("catch--", error);
          });
      } else {

        axios
          .post(SAVE_GROUP, payload)
          .then((response) => {
           
            let options = {};
            options = {
              place: "tr",
              message: "Saved Successfully",
              type: "success",

              autoDismiss: 5,
            };
            notificationAlertRef.current.notificationAlert(options);
            setTimeout(() => {
              navigate.push("/admin/groups/groups");
            }, 1000)


          })
          .catch((error) => {
            console.log("catch--", error);
          });

      }
    }
  };

  const validate = () => {
   
    const len = contacts.length;
    const index = len-1;


    let errors = {...error}
    const onlylettersRegex = /^([^0-9]*)$/;
    // const onlylettersRegex =/^[a-zA-Z]+$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    contacts.map((it,index)=>{

   
    if (!groupname) {
      errors.groupname = "Group name required"
    } else if (groupname.length < 4) {
      errors.groupname = "Name Too Short"
    }
    if (ismanual == 0) {
      if (!contacts[index]?.name) {
        errors.name = "Name required"
      } else if (contacts[index]?.name.length < 4) {
        errors.name = "Name Too Short"
      } else if (!contacts[index]?.name?.match(onlylettersRegex)) {
        errors.name = "Please enter valid name"
      }
      if (!contacts[index]?.mobile) {
        errors.mobile = "Mobile number required"
      }
      else if (contacts[index]?.mobile?.length != 10) {
        errors.mobile = "Number should be 10 digits"
      }
      if (!contacts[index]?.email) {
        errors.email = "Email required"
      }
      else if (!contacts[index]?.email?.match(emailRegex)) {
        errors.email = "Please provide valid email"
      }
    } else {
      if (!file) {
        errors.file = "File required"
      }

    }
  })
    return errors;
  }
  const addcontact = () => {
    const index = contacts?.length - 1;
    const cleanedObj = error&&Object?.fromEntries(
      Object?.entries(error)?.filter(([_, value]) => value !== "" && value !== null && value !== undefined)
  );
    if (contacts[index]?.name != "" ) {
      setContacts([...contacts, {
        name: "",
        mobile: "",
        email: ""
      }])

    }


  }

  const removeContact = (i) => {
    let contact = contacts.filter((data, index) => index != i);

    setContacts(contact);
  };

  const isgrpexist=(val)=>{
    setGroupname(val)
    

  const isgrpexst= groupnames[0]?.filter((item,i)=>item?.name?.toLowerCase()===val?.toLowerCase())
 
    if(isgrpexst?.length>0){
    setError({...error,groupname:"Already Exist"})
    }else{
      setError({...error,groupname:""})
    }
   
  
  }

  return (
    <>
      <div className="content pd-0">
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Row>
                <Row>
                  <Col sm="10">
                    <h4 className="mt-4 add-content" style={{ width: "200px" }} onClick={() => navigate.push("/admin/groups/groups")}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"

                      >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </Button>
                      {props?.location?.state?.id ? "Update Group" : "Create Group"}
                    </h4>
                  </Col>
                </Row>

                <Col md="10" sm="8">
                  <Row>
                    <Col sm="4" className="mb-4">
                      <MDBInput
                        label="Group Name"
                        type="text"
                        name="groupname"
                        value={groupname}
                        onChange={val => {isgrpexist(val.target.value)}}
                      />
                      <span style={{ color: "red" }}>{error?.groupname}</span>
                    </Col>

                    <Col sm="4" className="mb-2 mt-2">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">File</span>
                        <CustomInput
                          type="switch"
                          id="switch-5"
                          className="mt-n4"
                          checked={ismanual === 0 ? true : false}
                          //checked={isActive.current}
                          onChange={(e) => {

                            setIsManual(e.target.checked == true ? 0 : 1)
                          }
                          }
                        />
                        <span className="ml-n2">Manual</span>
                      </div>
                    </Col>
                    {
                      ismanual == 1 && <Col md="5" sm="12" className="">
                        <Label>
                          Bulk Upload (<b>Upload CSV File</b>)
                        </Label>

                        <FormGroup>
                          <input type="file" accept=".csv" style={{
                            opacity: "1",
                            position: "initial",
                            border: "solid 1px #eee",
                          }} onChange={(e) => {
                            setFile(e.target.files[0]);

                          }} />

                          <a href={SampleCSV} download="group contact sample file">
                            {" "}
                            <p style={{ marginLeft: "40%", color: "#e14eca" }}>
                              *Download sample csv file
                            </p>
                          </a>
                        </FormGroup>

                        {error?.file && (
                          <span style={{ color: "red" }}>
                            {error?.file}
                          </span>
                        )}
                        
                      </Col>
                      
                    }

                  </Row>




                  {
                    ismanual == 0 && contacts?.map((item, index) => {
                      return <Row>
                        {/* {error?.name && (
                          <span style={{ color: "red" }}>
                            {error?.name}
                          </span>
                        )}
                        {error?.mobile && (
                          <span style={{ color: "red" }}>
                            {error?.mobile}
                          </span>
                        )}{error?.email && (
                          <span style={{ color: "red" }}>
                            {error?.email}
                          </span>
                        )} */}
                        <Col sm="3" className="mb-3">
                          <MDBInput
                            label="Name"
                            type="text"
                            name="name"
                            value={item?.name}
                            onChange={(val) => onchangeHandler(val, index)}
                          />
                          <span style={{ color: "red" }}>{contacts.length-1===index&&error?.name}</span>
                        </Col>
                        <Col sm="3" className="mb-3">
                          <MDBInput
                            label="Mobile Number"
                            type="number"
                            maxLength={10}
                            name="mobile"
                            value={item?.mobile}
                            onChange={(val) => onchangeHandler(val, index)}
                          />
                          <span style={{ color: "red" }}>{contacts.length-1===index&&error?.mobile}</span>
                        </Col>
                        <Col sm="3" className="mb-3">
                          <MDBInput
                            label="Email Id"
                            type="text"
                            name="email"
                            value={item?.email}
                            onChange={(val) => onchangeHandler(val, index)}
                          />
                          <span style={{ color: "red" }}>{contacts.length-1===index&&error?.email}</span>
                        </Col>

                        {
                          index > 0 ?
                            <Col sm="1" className="mb-3">
                              <Button
                                className="btn btn-icon btn-remove-style m-0"
                                onClick={() => removeContact(index)}

                              >
                                <i class="fa fa-minus" aria-hidden="true"></i>
                              </Button>
                            </Col>
                            :
                            <Col sm="1" className="mb-3">
                              <Button
                                className="btn btn-icon btn-add-style m-0"
                                onClick={() => addcontact()}
                              >
                                <i class="fa fa-plus" aria-hidden="true"></i>
                              </Button>
                            </Col>

                        }

                      </Row>
                    })
                  }
                </Col>

              </Row>
              <Row>
                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={() => submitgroup()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreateGroup;
